<ng-template
  #treeListTmp
  let-dataSource="dataSource"
  let-noDataText="noDataText"
  let-disabled="disabled"
  let-allowReordering="allowReordering"
  let-showDragIcons="showDragIcons"
  let-allowDropInsideItem="allowDropInsideItem"
  let-onDragChange="onDragChange"
  let-onAdd="onAdd"
  let-onReorder="onReorder"
  let-onRemove="onRemove"
  let-gridTitle="gridTitle"
  let-onRowPrepared="onRowPrepared"
>
  <dx-tree-list
    [dataSource]="dataSource"
    itemsExpr="teamMembers"
    dataStructure="tree"
    height="100%"
    [wordWrapEnabled]="false"
    [autoExpandAll]="true"
    [rowAlternationEnabled]="true"
    [noDataText]="noDataText"
    [disabled]="disabled"
    [filterMode]="'fullBranch'"
    (onRowPrepared)="onRowPrepared ? onRowPrepared($event) : undefined"
  >
    <dxo-load-panel [enabled]="true"></dxo-load-panel>

    <dxo-header-filter [visible]="true" [allowSearch]="true"> </dxo-header-filter>

    <dxo-row-dragging
      [group]="'hierarchy'"
      [allowDropInsideItem]="allowReordering ?? false"
      [allowReordering]="allowReordering ?? false"
      [allowDropInsideItem]="allowDropInsideItem ?? false"
      [showDragIcons]="showDragIcons ?? false"
      [onAdd]="onAdd"
      [onRemove]="onRemove"
      [onReorder]="onReorder"
      [onDragChange]="onDragChange"
    ></dxo-row-dragging>

    <dxo-toolbar>
      <dxi-item location="before">
        <div *dxTemplate>
          <h5 class="mx-2 agency-hierarchy-management__toolbar-title">{{ gridTitle }}</h5>
        </div>
      </dxi-item>

      <dxi-item
        name="columnChooserButton"
        cssClass="agency-hierarchy-management__toolbar-control"
        location="after"
      ></dxi-item>

      <!-- <dxi-item name="searchPanel" cssClass="agency-hierarchy-managemend__toolbar-control"></dxi-item> -->
    </dxo-toolbar>

    <dxo-scrolling [mode]="'virtual'" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>

    <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>

    <dxo-column-chooser [enabled]="true"></dxo-column-chooser>

    <dxi-column
      [dataField]="['agent', AgentKeys.p_agent_name] | path"
      caption="Agent Name"
      [minWidth]="300"
      cellTemplate="agentNameCellTemplate"
    ></dxi-column>

    <div *dxTemplate="let cellInfo of 'agentNameCellTemplate'">
      @if (cellInfo?.data?.isShadowLead) {
        <div class="agency-hierarchy-management__shadow-lead-cell">
          <div class="agency-hierarchy-management__shadow-lead-title">No MGA Lead Assigned</div>
          <div class="agency-hierarchy-management__shadow-lead-caption">
            Lead position open. Assigned lead will appear here.
          </div>
        </div>
      } @else {
        {{ cellInfo?.value }}
      }
    </div>

    <dxi-column [dataField]="['agent', AgentKeys.p_agent_id] | path" caption="Agent Id" [width]="100"></dxi-column>

    <dxi-column
      [dataField]="['agent', AgentKeys.p_agency_id] | path"
      caption="Agency"
      [minWidth]="150"
      [visible]="false"
    >
      <dxo-lookup
        [dataSource]="agencyNamesDataSourceConfiguration"
        [valueExpr]="LookupKeys.value"
        [displayExpr]="LookupKeys.description"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      [dataField]="['agent', AgentKeys.is_manager] | path"
      caption="Is TL"
      [alignment]="'center'"
      [width]="120"
    >
      <dxo-lookup
        [dataSource]="trueFalseLookup"
        [valueExpr]="LookupKeys.value"
        [displayExpr]="LookupKeys.description"
      ></dxo-lookup>
    </dxi-column>

    <dxi-column
      [dataField]="['agent', AgentKeys.is_credited] | path"
      caption="Is AD"
      [alignment]="'center'"
      [width]="120"
    >
      <dxo-lookup
        [dataSource]="trueFalseLookup"
        [valueExpr]="LookupKeys.value"
        [displayExpr]="LookupKeys.description"
      ></dxo-lookup>
    </dxi-column>
  </dx-tree-list>
</ng-template>

<dx-splitter [separatorSize]="16" height="100%">
  <dxi-item [resizable]="true" [minSize]="300">
    <ng-container
      *ngTemplateOutlet="
        treeListTmp;
        context: {
          dataSource: freeAgentsDataSourceSig(),
          noDataText: hasOriginMgaSig() ? 'No Unassigned Agents' : 'MGA not Selected',
          disabled: !hasOriginMgaSig(),
          showDragIcons: !!hasOriginMgaSig(),
          onRowPrepared: onMgaHierarchyRowPrepared,
          gridTitle: unassignedGridTitle,
        }
      "
    ></ng-container>
  </dxi-item>

  <dxi-item [resizable]="true" [minSize]="300">
    <dx-splitter orientation="vertical" [separatorSize]="16">
      @if (hasTargetMgaSig()) {
        <dxi-item [resizable]="true" [collapsible]="true" collapsedSize="48px">
          <ng-container
            *ngTemplateOutlet="
              treeListTmp;
              context: {
                dataSource: targetMgaHierarchyDataSourceSig(),
                noDataText: targetMgaNoDataTextSig(),
                disabled: false,
                showDragIcons: true,
                allowReordering: true,
                allowDropInsideItem: true,
                onAdd: handleAddAgentToTarget,
                onReorder: handleReorderMgaHierarchy,
                onDragChange: handleDragChange,
                onRowPrepared: onMgaHierarchyRowPrepared,
                gridTitle: targetMgaGridTitleSig(),
              }
            "
          ></ng-container>
        </dxi-item>
      }

      <dxi-item [resizable]="true" [collapsible]="true" collapsedSize="48px">
        <ng-container
          *ngTemplateOutlet="
            treeListTmp;
            context: {
              dataSource: originMgaHierarchyDataSourceSig(),
              noDataText: originMgaNoDataTextSig(),
              disabled: !hasOriginMgaSig(),
              showDragIcons: true,
              allowReordering: true,
              allowDropInsideItem: true,
              onAdd: handleAddFreeAgents,
              onReorder: handleReorderMgaHierarchy,
              onDragChange: handleDragChange,
              onRowPrepared: onMgaHierarchyRowPrepared,
              gridTitle: originMgaGridTitleSig(),
            }
          "
        ></ng-container>
      </dxi-item>
    </dx-splitter>
  </dxi-item>
</dx-splitter>
